export default "__VITE_ASSET__MoFlxVLQ__"